<template>
  <v-container fluid>
    <div class="tables-basic">
      <h1 class="page-title mt-1 mb-2">Ubah Password</h1>
      <v-row>
        <v-col cols="12">
          <v-form ref="form" v-model="valid" lazy-validation>
            <v-dialog v-model="notifDialog" persistent max-width="350">
              <v-card>
                <v-card-title class="headline justify-center">
                  <v-img
                    max-height="44"
                    max-width="42"
                    src="@/assets/check-green.png"
                  ></v-img>
                </v-card-title>
                <v-card-text class="text-center"
                  >Password berhasil diubah.</v-card-text
                >
                <v-card-text class="text-center">
                  <v-spacer></v-spacer>
                  <v-btn
                    class="text-capitalize ml-2"
                    small
                    color="primary"
                    elevation="0"
                    @click="toDashboard"
                  >
                    Kembali ke Beranda
                  </v-btn>
                </v-card-text>
              </v-card>
            </v-dialog>
            <v-dialog v-model="dialogErr" persistent max-width="350">
              <v-card>
                <v-card-title class="headline justify-center">
                  <v-img
                    max-height="44"
                    max-width="42"
                    src="@/assets/alert.jpg"
                  ></v-img>
                </v-card-title>
                <v-card-text class="text-center">{{ pesanError }}</v-card-text>
                <v-card-text class="text-center">
                  <v-spacer></v-spacer>
                  <v-btn
                    class="text-capitalize ml-2"
                    small
                    color="primary"
                    elevation="0"
                    @click="
                      (dialogErr = false),
                        (password = ''),
                        (newPassword = ''),
                        (confirmPassword = '')
                    "
                  >
                    Coba Lagi
                  </v-btn>
                </v-card-text>
              </v-card>
            </v-dialog>
            <v-text-field
              :type="value ? 'password' : 'text'"
              :append-icon="value ? 'mdi-eye-off' : 'mdi-eye'"
              @click:append="() => (value = !value)"
              label="Sandi saat ini"
              :rules="passwordRules"
              outlined
              dense
              hide-details="auto"
              v-model="password"
              autocomplete="off"
            ></v-text-field>
            <v-text-field
              :type="value2 ? 'password' : 'text'"
              :append-icon="value2 ? 'mdi-eye-off' : 'mdi-eye'"
              @click:append="() => (value2 = !value2)"
              label="Sandi baru"
              :rules="passwordRules"
              outlined
              dense
              hide-details="auto"
              v-model="newPassword"
              autocomplete="off"
            ></v-text-field>
            <v-text-field
              :type="value3 ? 'password' : 'text'"
              :append-icon="value3 ? 'mdi-eye-off' : 'mdi-eye'"
              @click:append="() => (value3 = !value3)"
              label="Konfirmasi Sandi Baru"
              outlined
              dense
              hide-details="auto"
              :rules="confirmPasswordRules"
              v-model="confirmPassword"
              autocomplete="off"
            ></v-text-field>
            <v-btn
              class="text-capitalize mr-3"
              medium
              color="primary"
              @click="handleChangePass"
              elevation="0"
              style="border-radius: 10px"
            >
              Konfirmasi</v-btn
            >
            <v-btn
              class="text-capitalize"
              medium
              text
              color="black"
              to="/profile"
              style="border: 2px solid pink; border-radius: 10px"
            >
              Batal</v-btn
            >
          </v-form>
        </v-col>
      </v-row>
    </div>
  </v-container>
</template>

<script>
import { mapActions } from "vuex";

export default {
  name: "ChangePassword",
  data() {
    return {
      notifDialog: false,
      dialogErr: false,
      pesanError: "",
      value: String,
      value2: String,
      value3: String,
      valid: true,
      password: "",
      passwordRules: [
        (v) => !!v || "Sandi harus diisi",
        // v => (v && v.length <= 8) || 'Sandi minimal 8 karakter, mengandung angka, uppercase dan lowercase',
      ],
      newPassword: "",
      newPasswordRules: [
        (v) => !!v || "Sandi baru harus diisi",
        (v) => {
          // const pattern = /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])(?=.{8,})/;
          const pattern = /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.{8,})/;
          return (
            (v && pattern.test(v)) ||
            "Sandi minimal 8 karakter, mengandung angka, uppercase dan lowercase"
          );
        },
        (v) =>
          v !== this.password ||
          "Sandi baru tidak boleh sama dengan Sandi lama",
      ],
      confirmPassword: "",
      confirmPasswordRules: [
        (value) => !!value || "Konfirmasi sandi baru harus diisi",
        (value) =>
          value === this.newPassword || "Konfirmasi sandi baru tidak sesuai",
      ],
    };
  },
  methods: {
    ...mapActions(["changeTitleApp", "changePass", "refreshToken"]),
    toDashboard() {
      this.notifDialog = false;
      this.$router.push(`/dashboard`);
    },
    handleChangePass: function(e) {
      e.preventDefault();
      if (this.$refs.form.validate()) {
        let password = this.password;
        let newPassword = this.newPassword;
        this.refreshToken().then(() => {
          this.changePass({ password, newPassword })
            // .then((response) => {
            //   return this.$helpers.handleSuccess(response);
            // })
            .then((response) => {
              let data = response.data;
              this.pesanError = data.message;
              if (data.status == 1) {
                this.notifDialog = true;
              } else {
                this.dialogErr = true;
              }
            })
            .catch((error) => {
              this.$helpers.handleError(error);
            });
        });
      }
    },
  },
  created() {
    this.requiredFeature("CHANGE_PASS");
    this.changeTitleApp("Ubah Password");
  },
};
</script>

<style scoped src="./ChangePass.scss" lang="scss"></style>
